import { Col, Input, Row } from 'antd';
import React from 'react';
import { useGlobalState } from './GlobalState';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import moment from 'moment';
import dayjs from 'dayjs';

function Step2({ form }) {
  const [formState, setFormState] = useGlobalState('formState');
  return (
    <div style={{ color: '#606060' }}>
      {form?.form_element.address && (
        <>
          <div className='fs-24 gSemiBold'>Address:</div>
          <Row gutter={[10, 10]} className='mg-bottom-30'>
            <Col xs={24} sm={12}>
              <Input
                className='gMedium input-fs'
                placeholder='Address Line 1'
                value={formState.address_1}
                onChange={(e) =>
                  setFormState((prevState) => ({
                    ...prevState,
                    address_1: e.target.value,
                  }))
                }
              />
            </Col>
            <Col xs={24} sm={12}>
              <Input
                className='gMedium input-fs'
                placeholder='Address Line 2'
                value={formState.address_2}
                onChange={(e) =>
                  setFormState((prevState) => ({
                    ...prevState,
                    address_2: e.target.value,
                  }))
                }
              />
            </Col>
            <Col xs={24} sm={12}>
              <Input
                className='gMedium input-fs'
                placeholder='Town/City'
                value={formState.city}
                onChange={(e) =>
                  setFormState((prevState) => ({
                    ...prevState,
                    city: e.target.value,
                  }))
                }
              />
            </Col>
            <Col xs={24} sm={12}>
              <Input
                className='gMedium input-fs'
                placeholder='Country'
                value={formState.country}
                onChange={(e) =>
                  setFormState((prevState) => ({
                    ...prevState,
                    country: e.target.value,
                  }))
                }
              />
            </Col>
            <Col xs={24} sm={12}>
              <Input
                className='gMedium input-fs'
                placeholder='Post Code'
                value={formState.postcode}
                onChange={(e) =>
                  setFormState((prevState) => ({
                    ...prevState,
                    postcode: e.target.value,
                  }))
                }
              />
            </Col>
          </Row>
        </>
      )}
      <Row gutter={[10, 10]} className='mg-bottom-20'>
        {form?.form_element.date_of_birth && (
          <Col xs={24} sm={12}>
            <div className='fs-24 gSemiBold'>Date Of Birth:</div>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                size='small'
                disableFuture
                value={dayjs(formState?.date_of_birth, 'DD/MM/YYYY')}
                style={{ fontFamily: 'gRegular', color: 'white' }}
                onChange={(value) => {
                  setFormState((prevState) => ({
                    ...prevState,
                    date_of_birth: moment(value?.$d)
                      .local()
                      .format('DD/MM/YYYY'),
                  }));
                }}
                slotProps={{
                  textField: {
                    size: 'small',
                    error: false,
                  },
                }}
                className='br5 gRegular w-full bg-white'
                id='gRegular'
                format={'DD/MM/YYYY'}
              ></DatePicker>
            </LocalizationProvider>
          </Col>
        )}
        {form?.form_element.car_registration && (
          <Col xs={24} sm={12}>
            <div className='fs-24 gSemiBold'>Car Registration:</div>
            <Input
              className='mg-bottom-10 gMedium'
              style={{ height: 57 }}
              onKeyDown={(e) => {
                if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                  e.preventDefault(); // Disable arrow keys
                }
              }}
              onWheel={(e) => e.preventDefault()} // Disable mouse wheel
              value={formState.vehicle_registration_no}
              placeholder='e.g. AA12 AAA'
              onChange={(e) =>
                setFormState((prevState) => ({
                  ...prevState,
                  vehicle_registration_no: e.target.value,
                }))
              }
            />
          </Col>
        )}
        {form?.custom_field_value && (
          <Col xs={24} sm={12}>
            <div className='fs-24 gSemiBold'>{form?.custom_field_value}:</div>
            <Input
              className='mg-bottom-10 gMedium'
              style={{ height: 57 }}
              onKeyDown={(e) => {
                if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                  e.preventDefault(); // Disable arrow keys
                }
              }}
              onWheel={(e) => e.preventDefault()} // Disable mouse wheel
              value={formState?.custom_field}
              placeholder=''
              onChange={(e) =>
                setFormState((prevState) => ({
                  ...prevState,
                  custom_field: e.target.value,
                }))
              }
            />
          </Col>
        )}
      </Row>
    </div>
  );
}

export default Step2;
